import level_1 from './level_1';
import level_2 from './level_2';
export const feedback_level_1 = [
    {
        score: 0,
        message: `  
              <span style='font-size: calc(1.8vh + 1.8vw)' class='feedback-message'>Ohhh… ¡Esta vez no fue suficiente!</span>
              <span style='font-family: var(--font-poppins); font-weight: 300; font-size: calc(1.8vh + 1.8vw)' class='feedback-message'>¡Inténtalo de nuevo!</span>
              `,
        lottieSrc: 'animations/genio-mal.json'
    },
    {
        score: 60,
        message: `
              <span style='font-size: calc(1.8vh + 1.8vw)' class='feedback-message'>¡Genial!</span>
              <span style='font-family: var(--font-poppins);font-weight: 300;font-size: calc(1.8vh + 1.8vw); line-height: calc(2vh + 2vw);' class='feedback-message'>Tienes lo necesario para subir de nivel.</span>
              <span style='font-family: var(--font-poppins); font-weight: 300; font-size:calc(1.8vh + 1.8vw) ;margin-top: calc(1.8vh + 1.8vw); line-height: calc(2vh + 2vw);' class='feedback-message'>¡Y consigue un regalito!</span>`,
        lottieSrc: 'animations/genio-bien.json'
    }
];
export const feedback_level_2 = [
    {
        score: 0,
        message: `
              <span style='font-size: calc(1.8vh + 1.8vw)' class='feedback-message'>¡Casi lo logras!</span>
              <span style='font-family: var(--font-poppins);font-weight: 300;font-size: calc(1.8vh + 1.8vw); line-height: calc(2vh + 2vw)' class='feedback-message'>Estás muy cerca de ser Pro.</span>
              <span style='font-family: var(--font-poppins); font-weight: 300; font-size: calc(1.8vh + 1.8vw); margin-top: calc(1.8vh + 1.8vw); line-height: calc(2vh + 2vw)' class='feedback-message'>¡Vuelve a intentarlo!</span>
              `,
        lottieSrc: 'animations/genio-mal.json'
    },
    {
        score: 60,
        message: `
              <span style='font-size: calc(1.8vh + 1.8vw)' class='feedback-message'>¡IMPRESIONANTE!</span>
              <span style='font-family: var(--font-poppins); font-weight: 300; font-size: calc(1.8vh + 1.8vw); line-height: calc(2vh + 2vw)' class='feedback-message'><b>Nivel Pro</b> conseguido.</span>
              <span style='font-family: var(--font-poppins); font-weight: 300; font-size: calc(1.8vh + 1.8vw); margin-top: calc(2.5vh + 2.5vw); line-height: calc(2vh + 2vw)' class='feedback-message'>Este regalo es tuyo.</span>
              <a href='/comic_fusion_2025C.pdf' target='_blank' style='padding: calc(1.5vh + 1.5vw);font-size: calc(1.8vh + 1.8vw); border-radius: 30px; background-color: var(--win-color); color: #fff; text-decoration-line: none;margin-top: calc(1.8vh + 1.8vw);' class='feedback-message'>Ver regalo</a>
              `,
        lottieSrc: 'animations/genio-bien.json'
    }
];
export const questions = {
    novato: level_1,
    experto: level_2,
};
